import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMdrtCenterFullLogoReverse = props => {
  const $ = _c(142);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <clipPath id="mdrt-center-full-logo-reverse_svg__a" clipPathUnits="userSpaceOnUse"><path d="M-46.873 0h360v-83.413h-360Z" /></clipPath>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <clipPath id="mdrt-center-full-logo-reverse_svg__b" clipPathUnits="userSpaceOnUse"><path d="M-37.47 19.566h360v-83.413h-360Z" /></clipPath>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <clipPath id="mdrt-center-full-logo-reverse_svg__c" clipPathUnits="userSpaceOnUse"><path d="M-75.061 28.97h360v-83.413h-360Z" /></clipPath>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <clipPath id="mdrt-center-full-logo-reverse_svg__d" clipPathUnits="userSpaceOnUse"><path d="M-31.364 28.962h360V-54.45h-360Z" /></clipPath>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <clipPath id="mdrt-center-full-logo-reverse_svg__e" clipPathUnits="userSpaceOnUse"><path d="M-50.158 47.776h360v-83.413h-360Z" /></clipPath>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <clipPath id="mdrt-center-full-logo-reverse_svg__f" clipPathUnits="userSpaceOnUse"><path d="M-65.667 10.163h360V-73.25h-360Z" /></clipPath>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <clipPath id="mdrt-center-full-logo-reverse_svg__g" clipPathUnits="userSpaceOnUse"><path d="M-37.47.76h360v-83.414h-360Z" /></clipPath>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <clipPath id="mdrt-center-full-logo-reverse_svg__h" clipPathUnits="userSpaceOnUse"><path d="M-21.96 38.373h360V-45.04h-360Z" /></clipPath>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <clipPath id="mdrt-center-full-logo-reverse_svg__i" clipPathUnits="userSpaceOnUse"><path d="M-59.552 38.373h360V-45.04h-360Z" /></clipPath>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <clipPath id="mdrt-center-full-logo-reverse_svg__j" clipPathUnits="userSpaceOnUse"><path d="M-75.071 19.566h360v-83.413h-360Z" /></clipPath>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <clipPath id="mdrt-center-full-logo-reverse_svg__k" clipPathUnits="userSpaceOnUse"><path d="M-37.47 10.163h360V-73.25h-360Z" /></clipPath>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <clipPath id="mdrt-center-full-logo-reverse_svg__l" clipPathUnits="userSpaceOnUse"><path d="M-21.956 28.962h360V-54.45h-360Z" /></clipPath>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <clipPath id="mdrt-center-full-logo-reverse_svg__m" clipPathUnits="userSpaceOnUse"><path d="M-95.931 78.447h360V-4.966h-360Z" /></clipPath>;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <clipPath id="mdrt-center-full-logo-reverse_svg__n" clipPathUnits="userSpaceOnUse"><path d="M-101.79 71.402h360v-83.413h-360Z" /></clipPath>;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <clipPath id="mdrt-center-full-logo-reverse_svg__o" clipPathUnits="userSpaceOnUse"><path d="M0 83.413h360V0H0Z" /></clipPath>;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <clipPath id="mdrt-center-full-logo-reverse_svg__p" clipPathUnits="userSpaceOnUse"><path d="M-116.023 68.047h360v-83.413h-360Z" /></clipPath>;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <clipPath id="mdrt-center-full-logo-reverse_svg__q" clipPathUnits="userSpaceOnUse"><path d="M-124.077 78.682h360V-4.73h-360Z" /></clipPath>;
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  let t17;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <clipPath id="mdrt-center-full-logo-reverse_svg__r" clipPathUnits="userSpaceOnUse"><path d="M0 83.413h360V0H0Z" /></clipPath>;
    $[17] = t17;
  } else {
    t17 = $[17];
  }
  let t18;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <clipPath id="mdrt-center-full-logo-reverse_svg__s" clipPathUnits="userSpaceOnUse"><path d="M-134.838 71.402h360v-83.413h-360Z" /></clipPath>;
    $[18] = t18;
  } else {
    t18 = $[18];
  }
  let t19;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <clipPath id="mdrt-center-full-logo-reverse_svg__t" clipPathUnits="userSpaceOnUse"><path d="M-150.762 75.461h360V-7.952h-360Z" /></clipPath>;
    $[19] = t19;
  } else {
    t19 = $[19];
  }
  let t20;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <clipPath id="mdrt-center-full-logo-reverse_svg__u" clipPathUnits="userSpaceOnUse"><path d="M-159.56 68.047h360v-83.413h-360Z" /></clipPath>;
    $[20] = t20;
  } else {
    t20 = $[20];
  }
  let t21;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <clipPath id="mdrt-center-full-logo-reverse_svg__v" clipPathUnits="userSpaceOnUse"><path d="M-173.773 74.656h360V-8.757h-360Z" /></clipPath>;
    $[21] = t21;
  } else {
    t21 = $[21];
  }
  let t22;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <clipPath id="mdrt-center-full-logo-reverse_svg__w" clipPathUnits="userSpaceOnUse"><path d="M-179.968 78.783h360V-4.63h-360Z" /></clipPath>;
    $[22] = t22;
  } else {
    t22 = $[22];
  }
  let t23;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <clipPath id="mdrt-center-full-logo-reverse_svg__x" clipPathUnits="userSpaceOnUse"><path d="M-189.785 78.682h360V-4.73h-360Z" /></clipPath>;
    $[23] = t23;
  } else {
    t23 = $[23];
  }
  let t24;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <clipPath id="mdrt-center-full-logo-reverse_svg__y" clipPathUnits="userSpaceOnUse"><path d="M-202.036 74.656h360V-8.757h-360Z" /></clipPath>;
    $[24] = t24;
  } else {
    t24 = $[24];
  }
  let t25;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <clipPath id="mdrt-center-full-logo-reverse_svg__z" clipPathUnits="userSpaceOnUse"><path d="M-205.68 71.402h360v-83.413h-360Z" /></clipPath>;
    $[25] = t25;
  } else {
    t25 = $[25];
  }
  let t26;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <clipPath id="mdrt-center-full-logo-reverse_svg__A" clipPathUnits="userSpaceOnUse"><path d="M-212.077 77.692h360V-5.72h-360Z" /></clipPath>;
    $[26] = t26;
  } else {
    t26 = $[26];
  }
  let t27;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <clipPath id="mdrt-center-full-logo-reverse_svg__B" clipPathUnits="userSpaceOnUse"><path d="M-224.16 72.828h360v-83.413h-360Z" /></clipPath>;
    $[27] = t27;
  } else {
    t27 = $[27];
  }
  let t28;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <clipPath id="mdrt-center-full-logo-reverse_svg__C" clipPathUnits="userSpaceOnUse"><path d="M-233.775 78.682h360V-4.73h-360Z" /></clipPath>;
    $[28] = t28;
  } else {
    t28 = $[28];
  }
  let t29;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <clipPath id="mdrt-center-full-logo-reverse_svg__D" clipPathUnits="userSpaceOnUse"><path d="M-249.266 78.447h360V-4.966h-360Z" /></clipPath>;
    $[29] = t29;
  } else {
    t29 = $[29];
  }
  let t30;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <clipPath id="mdrt-center-full-logo-reverse_svg__E" clipPathUnits="userSpaceOnUse"><path d="M-255.126 71.402h360v-83.413h-360Z" /></clipPath>;
    $[30] = t30;
  } else {
    t30 = $[30];
  }
  let t31;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <clipPath id="mdrt-center-full-logo-reverse_svg__F" clipPathUnits="userSpaceOnUse"><path d="M0 83.413h360V0H0Z" /></clipPath>;
    $[31] = t31;
  } else {
    t31 = $[31];
  }
  let t32;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <clipPath id="mdrt-center-full-logo-reverse_svg__G" clipPathUnits="userSpaceOnUse"><path d="M-269.359 68.047h360v-83.413h-360Z" /></clipPath>;
    $[32] = t32;
  } else {
    t32 = $[32];
  }
  let t33;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <clipPath id="mdrt-center-full-logo-reverse_svg__H" clipPathUnits="userSpaceOnUse"><path d="M-277.412 78.682h360V-4.73h-360Z" /></clipPath>;
    $[33] = t33;
  } else {
    t33 = $[33];
  }
  let t34;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <clipPath id="mdrt-center-full-logo-reverse_svg__I" clipPathUnits="userSpaceOnUse"><path d="M-288.676 77.273h360V-6.14h-360Z" /></clipPath>;
    $[34] = t34;
  } else {
    t34 = $[34];
  }
  let t35;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <clipPath id="mdrt-center-full-logo-reverse_svg__J" clipPathUnits="userSpaceOnUse"><path d="M-297.353 71.402h360v-83.413h-360Z" /></clipPath>;
    $[35] = t35;
  } else {
    t35 = $[35];
  }
  let t36;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <clipPath id="mdrt-center-full-logo-reverse_svg__K" clipPathUnits="userSpaceOnUse"><path d="M-311.45 71.2h360v-83.412h-360Z" /></clipPath>;
    $[36] = t36;
  } else {
    t36 = $[36];
  }
  let t37;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <clipPath id="mdrt-center-full-logo-reverse_svg__L" clipPathUnits="userSpaceOnUse"><path d="M-320.63 71.2h360v-83.412h-360Z" /></clipPath>;
    $[37] = t37;
  } else {
    t37 = $[37];
  }
  let t38;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <clipPath id="mdrt-center-full-logo-reverse_svg__M" clipPathUnits="userSpaceOnUse"><path d="M-331.538 74.656h360V-8.757h-360Z" /></clipPath>;
    $[38] = t38;
  } else {
    t38 = $[38];
  }
  let t39;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = <clipPath id="mdrt-center-full-logo-reverse_svg__N" clipPathUnits="userSpaceOnUse"><path d="M-335.285 77.692h360V-5.72h-360Z" /></clipPath>;
    $[39] = t39;
  } else {
    t39 = $[39];
  }
  let t40;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = <clipPath id="mdrt-center-full-logo-reverse_svg__O" clipPathUnits="userSpaceOnUse"><path d="M-342.804 77.692h360V-5.72h-360Z" /></clipPath>;
    $[40] = t40;
  } else {
    t40 = $[40];
  }
  let t41;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = <clipPath id="mdrt-center-full-logo-reverse_svg__P" clipPathUnits="userSpaceOnUse"><path d="M-93.884.485h360v-83.413h-360Z" /></clipPath>;
    $[41] = t41;
  } else {
    t41 = $[41];
  }
  let t42;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = <clipPath id="mdrt-center-full-logo-reverse_svg__Q" clipPathUnits="userSpaceOnUse"><path d="M-134.177 22.897h360v-83.413h-360Z" /></clipPath>;
    $[42] = t42;
  } else {
    t42 = $[42];
  }
  let t43;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <clipPath id="mdrt-center-full-logo-reverse_svg__R" clipPathUnits="userSpaceOnUse"><path d="M-162.198 12.944h360v-83.413h-360Z" /></clipPath>;
    $[43] = t43;
  } else {
    t43 = $[43];
  }
  let t44;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = <clipPath id="mdrt-center-full-logo-reverse_svg__S" clipPathUnits="userSpaceOnUse"><path d="M-183.147 4.638h360v-83.413h-360Z" /></clipPath>;
    $[44] = t44;
  } else {
    t44 = $[44];
  }
  let t45;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = <clipPath id="mdrt-center-full-logo-reverse_svg__T" clipPathUnits="userSpaceOnUse"><path d="M-221.12.036h360v-83.413h-360Z" /></clipPath>;
    $[45] = t45;
  } else {
    t45 = $[45];
  }
  let t46;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = <clipPath id="mdrt-center-full-logo-reverse_svg__U" clipPathUnits="userSpaceOnUse"><path d="M-236.083.485h360v-83.413h-360Z" /></clipPath>;
    $[46] = t46;
  } else {
    t46 = $[46];
  }
  let t47;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t47 = <clipPath id="mdrt-center-full-logo-reverse_svg__V" clipPathUnits="userSpaceOnUse"><path d="M-256.563.485h360v-83.413h-360Z" /></clipPath>;
    $[47] = t47;
  } else {
    t47 = $[47];
  }
  let t48;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t48 = <clipPath id="mdrt-center-full-logo-reverse_svg__W" clipPathUnits="userSpaceOnUse"><path d="M-290.662 4.638h360v-83.413h-360Z" /></clipPath>;
    $[48] = t48;
  } else {
    t48 = $[48];
  }
  let t49;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t49 = <clipPath id="mdrt-center-full-logo-reverse_svg__X" clipPathUnits="userSpaceOnUse"><path d="M-307.886.485h360v-83.413h-360Z" /></clipPath>;
    $[49] = t49;
  } else {
    t49 = $[49];
  }
  let t50;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t50 = <clipPath id="mdrt-center-full-logo-reverse_svg__Y" clipPathUnits="userSpaceOnUse"><path d="M-337.26 12.944h360v-83.413h-360Z" /></clipPath>;
    $[50] = t50;
  } else {
    t50 = $[50];
  }
  let t51;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t51 = <clipPath id="mdrt-center-full-logo-reverse_svg__Z" clipPathUnits="userSpaceOnUse"><path d="M-93.261 44.716h360v-83.413h-360Z" /></clipPath>;
    $[51] = t51;
  } else {
    t51 = $[51];
  }
  let t52;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t52 = <clipPath id="mdrt-center-full-logo-reverse_svg__aa" clipPathUnits="userSpaceOnUse"><path d="M-107.108 52.205h360v-83.413h-360Z" /></clipPath>;
    $[52] = t52;
  } else {
    t52 = $[52];
  }
  let t53;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t53 = <clipPath id="mdrt-center-full-logo-reverse_svg__ab" clipPathUnits="userSpaceOnUse"><path d="M-116.486 42.04h360v-83.414h-360Z" /></clipPath>;
    $[53] = t53;
  } else {
    t53 = $[53];
  }
  let t54;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t54 = <clipPath id="mdrt-center-full-logo-reverse_svg__ac" clipPathUnits="userSpaceOnUse"><path d="M-132.592 37.129h360v-83.413h-360Z" /></clipPath>;
    $[54] = t54;
  } else {
    t54 = $[54];
  }
  let t55;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t55 = <clipPath id="mdrt-center-full-logo-reverse_svg__ad" clipPathUnits="userSpaceOnUse"><path d="M0 83.413h360V0H0Z" /></clipPath>;
    $[55] = t55;
  } else {
    t55 = $[55];
  }
  let t56;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t56 = <clipPath id="mdrt-center-full-logo-reverse_svg__ae" clipPathUnits="userSpaceOnUse"><path d="M-153.165 37.129h360v-83.413h-360Z" /></clipPath>;
    $[56] = t56;
  } else {
    t56 = $[56];
  }
  let t57;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t57 = <clipPath id="mdrt-center-full-logo-reverse_svg__af" clipPathUnits="userSpaceOnUse"><path d="M-167.282 37.129h360v-83.413h-360Z" /></clipPath>;
    $[57] = t57;
  } else {
    t57 = $[57];
  }
  let t58;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t58 = <clipPath id="mdrt-center-full-logo-reverse_svg__ag" clipPathUnits="userSpaceOnUse"><path d="M-186.285 51.836h360v-83.413h-360Z" /></clipPath>;
    $[58] = t58;
  } else {
    t58 = $[58];
  }
  let t59;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t59 = <clipPath id="mdrt-center-full-logo-reverse_svg__ah" clipPathUnits="userSpaceOnUse"><path d="M-204.624 37.129h360v-83.413h-360Z" /></clipPath>;
    $[59] = t59;
  } else {
    t59 = $[59];
  }
  let t60;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t60 = <clipPath id="mdrt-center-full-logo-reverse_svg__ai" clipPathUnits="userSpaceOnUse"><path d="M-217.856 37.129h360v-83.413h-360Z" /></clipPath>;
    $[60] = t60;
  } else {
    t60 = $[60];
  }
  let t61;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t61 = <clipPath id="mdrt-center-full-logo-reverse_svg__aj" clipPathUnits="userSpaceOnUse"><path d="M-237.572 40.149h360v-83.413h-360Z" /></clipPath>;
    $[61] = t61;
  } else {
    t61 = $[61];
  }
  let t62;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t62 = <clipPath id="mdrt-center-full-logo-reverse_svg__ak" clipPathUnits="userSpaceOnUse"><path d="M-253.382 51.836h360v-83.413h-360Z" /></clipPath>;
    $[62] = t62;
  } else {
    t62 = $[62];
  }
  let t63;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t63 = <clipPath id="mdrt-center-full-logo-reverse_svg__al" clipPathUnits="userSpaceOnUse"><path d="M-265.756 37.129h360v-83.413h-360Z" /></clipPath>;
    $[63] = t63;
  } else {
    t63 = $[63];
  }
  let t64;
  if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
    t64 = <clipPath id="mdrt-center-full-logo-reverse_svg__am" clipPathUnits="userSpaceOnUse"><path d="M-285.888 45.305h360v-83.413h-360Z" /></clipPath>;
    $[64] = t64;
  } else {
    t64 = $[64];
  }
  let t65;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t65 = <clipPath id="mdrt-center-full-logo-reverse_svg__an" clipPathUnits="userSpaceOnUse"><path d="M-296.42 50.093h360V-33.32h-360Z" /></clipPath>;
    $[65] = t65;
  } else {
    t65 = $[65];
  }
  let t66;
  if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
    t66 = <clipPath id="mdrt-center-full-logo-reverse_svg__ao" clipPathUnits="userSpaceOnUse"><path d="M-309.628 37.129h360v-83.413h-360Z" /></clipPath>;
    $[66] = t66;
  } else {
    t66 = $[66];
  }
  let t67;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t67 = <clipPath id="mdrt-center-full-logo-reverse_svg__ap" clipPathUnits="userSpaceOnUse"><path d="M0 83.413h360V0H0Z" /></clipPath>;
    $[67] = t67;
  } else {
    t67 = $[67];
  }
  let t68;
  if ($[68] === Symbol.for("react.memo_cache_sentinel")) {
    t68 = <clipPath id="mdrt-center-full-logo-reverse_svg__aq" clipPathUnits="userSpaceOnUse"><path d="M-342.084 45.796h360v-83.413h-360Z" /></clipPath>;
    $[68] = t68;
  } else {
    t68 = $[68];
  }
  let t69;
  if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
    t69 = <defs>{t0}{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}{t18}{t19}{t20}{t21}{t22}{t23}{t24}{t25}{t26}{t27}{t28}{t29}{t30}{t31}{t32}{t33}{t34}{t35}{t36}{t37}{t38}{t39}{t40}{t41}{t42}{t43}{t44}{t45}{t46}{t47}{t48}{t49}{t50}{t51}{t52}{t53}{t54}{t55}{t56}{t57}{t58}{t59}{t60}{t61}{t62}{t63}{t64}{t65}{t66}{t67}{t68}<clipPath id="mdrt-center-full-logo-reverse_svg__ar" clipPathUnits="userSpaceOnUse"><path d="M-352.4 39.502h360V-43.91h-360Z" /></clipPath></defs>;
    $[69] = t69;
  } else {
    t69 = $[69];
  }
  let t70;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t70 = <path d="M0 0a3.175 3.175 0 0 1-3.175-3.175v-19.547a3.175 3.175 0 0 1 6.35 0v19.547A3.175 3.175 0 0 1 0 0" clipPath="url(#mdrt-center-full-logo-reverse_svg__a)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 62.498 0)" />;
    $[70] = t70;
  } else {
    t70 = $[70];
  }
  let t71;
  if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
    t71 = <path d="M0 0h-34.295a3.175 3.175 0 0 1 0-6.35H0A3.175 3.175 0 0 1 0 0" clipPath="url(#mdrt-center-full-logo-reverse_svg__b)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 49.96 26.088)" />;
    $[71] = t71;
  } else {
    t71 = $[71];
  }
  let t72;
  if ($[72] === Symbol.for("react.memo_cache_sentinel")) {
    t72 = <path d="M0 0h-34.294a3.175 3.175 0 1 1 0-6.35H0A3.175 3.175 0 0 1 0 0" clipPath="url(#mdrt-center-full-logo-reverse_svg__c)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 100.082 38.626)" />;
    $[72] = t72;
  } else {
    t72 = $[72];
  }
  let t73;
  if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
    t73 = <path d="M0 0a3.175 3.175 0 0 1-3.175-3.175v-19.547a3.175 3.175 0 0 1 6.35 0v19.547A3.175 3.175 0 0 1 0 0" clipPath="url(#mdrt-center-full-logo-reverse_svg__d)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 41.818 38.616)" />;
    $[73] = t73;
  } else {
    t73 = $[73];
  }
  let t74;
  if ($[74] === Symbol.for("react.memo_cache_sentinel")) {
    t74 = <path d="M0 0h-9.391a3.176 3.176 0 0 1 0-6.35H0A3.174 3.174 0 1 1 0 0" clipPath="url(#mdrt-center-full-logo-reverse_svg__e)" style={{
      fill: "#aa1a2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 66.877 63.702)" />;
    $[74] = t74;
  } else {
    t74 = $[74];
  }
  let t75;
  if ($[75] === Symbol.for("react.memo_cache_sentinel")) {
    t75 = <path d="M0 0h-9.391a3.176 3.176 0 0 1 0-6.35H0A3.174 3.174 0 1 1 0 0" clipPath="url(#mdrt-center-full-logo-reverse_svg__f)" style={{
      fill: "#aa1a2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 87.557 13.55)" />;
    $[75] = t75;
  } else {
    t75 = $[75];
  }
  let t76;
  if ($[76] === Symbol.for("react.memo_cache_sentinel")) {
    t76 = <path d="M0 0h-9.391a3.176 3.176 0 0 1 0-6.35H0A3.174 3.174 0 1 1 0 0" clipPath="url(#mdrt-center-full-logo-reverse_svg__g)" style={{
      fill: "#aa1a2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 49.96 1.013)" />;
    $[76] = t76;
  } else {
    t76 = $[76];
  }
  let t77;
  if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
    t77 = <path d="M0 0h-9.391a3.176 3.176 0 0 1 0-6.35H0A3.174 3.174 0 1 1 0 0" clipPath="url(#mdrt-center-full-logo-reverse_svg__h)" style={{
      fill: "#aa1a2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 29.28 51.164)" />;
    $[77] = t77;
  } else {
    t77 = $[77];
  }
  let t78;
  if ($[78] === Symbol.for("react.memo_cache_sentinel")) {
    t78 = <path d="M0 0h-18.785a3.176 3.176 0 0 1 0-6.35H0A3.174 3.174 0 1 1 0 0" clipPath="url(#mdrt-center-full-logo-reverse_svg__i)" style={{
      fill: "#ff6b0f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 79.402 51.164)" />;
    $[78] = t78;
  } else {
    t78 = $[78];
  }
  let t79;
  if ($[79] === Symbol.for("react.memo_cache_sentinel")) {
    t79 = <path d="M0 0h-18.805a3.165 3.165 0 1 1 0-6.331H0A3.166 3.166 0 0 1 0 0" clipPath="url(#mdrt-center-full-logo-reverse_svg__j)" style={{
      fill: "#ff6b0f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 100.095 26.088)" />;
    $[79] = t79;
  } else {
    t79 = $[79];
  }
  let t80;
  if ($[80] === Symbol.for("react.memo_cache_sentinel")) {
    t80 = <path d="M0 0h-18.785a3.175 3.175 0 0 1 0-6.35H0A3.175 3.175 0 0 1 0 0" clipPath="url(#mdrt-center-full-logo-reverse_svg__k)" style={{
      fill: "#ff6b0f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 49.96 13.55)" />;
    $[80] = t80;
  } else {
    t80 = $[80];
  }
  let t81;
  if ($[81] === Symbol.for("react.memo_cache_sentinel")) {
    t81 = <path d="M0 0h-18.777a3.179 3.179 0 1 1 0-6.358H0A3.179 3.179 0 1 1 0 0" clipPath="url(#mdrt-center-full-logo-reverse_svg__l)" style={{
      fill: "#ff6b0f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 29.275 38.616)" />;
    $[81] = t81;
  } else {
    t81 = $[81];
  }
  let t82;
  if ($[82] === Symbol.for("react.memo_cache_sentinel")) {
    t82 = <path d="M0 0c1.275 0 2.029.805 2.029 2.013s-.805 2.03-2.046 2.03h-2.65V0Zm-.185 5.418c1.074 0 1.744.755 1.744 1.795S.922 8.958-.218 8.958h-2.449v-3.54ZM-4.328 10.4h4.143c1.997 0 3.439-1.107 3.439-3.019 0-1.157-.571-2.08-1.477-2.55v-.034c1.242-.368 1.947-1.543 1.947-2.868 0-2.231-1.728-3.372-3.808-3.372h-4.244z" clipPath="url(#mdrt-center-full-logo-reverse_svg__m)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 127.908 104.596)" />;
    $[82] = t82;
  } else {
    t82 = $[82];
  }
  let t83;
  if ($[83] === Symbol.for("react.memo_cache_sentinel")) {
    t83 = <path d="M0 0h1.627v-5.066c0-1.175.235-2.114 1.594-2.114 1.728 0 2.751 1.527 2.751 3.204V0h1.627v-8.489H6.023v1.125c0 .352.033.62.033.62h-.033C5.67-7.583 4.563-8.69 2.902-8.69.99-8.69 0-7.684 0-5.435Z" clipPath="url(#mdrt-center-full-logo-reverse_svg__n)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 135.72 95.202)" />;
    $[83] = t83;
  } else {
    t83 = $[83];
  }
  let t84;
  if ($[84] === Symbol.for("react.memo_cache_sentinel")) {
    t84 = <path d="M111.945 12.011h1.627V3.522h-1.627zm-.016 3.355h1.643v-1.66h-1.643z" clipPath="url(#mdrt-center-full-logo-reverse_svg__o)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 0 111.217)" />;
    $[84] = t84;
  } else {
    t84 = $[84];
  }
  let t85;
  if ($[85] === Symbol.for("react.memo_cache_sentinel")) {
    t85 = <path d="M0 0h1.627v-9.243c0-1.023.402-1.208.906-1.208.15 0 .285.017.285.017v-1.442s-.252-.034-.536-.034C1.358-11.91 0-11.659 0-9.528Z" clipPath="url(#mdrt-center-full-logo-reverse_svg__p)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 154.698 90.73)" />;
    $[85] = t85;
  } else {
    t85 = $[85];
  }
  let t86;
  if ($[86] === Symbol.for("react.memo_cache_sentinel")) {
    t86 = <path d="M0 0c1.257 0 2.449.889 2.449 3.053 0 1.51-.789 3.02-2.4 3.02-1.341 0-2.448-1.108-2.448-3.037C-2.399 1.191-1.41 0 0 0m-.218 7.481c1.962 0 2.617-1.341 2.617-1.341h.033s-.033.251-.033.57v3.925h1.627V-1.208H2.483v.805c0 .336.016.571.016.571h-.034S1.777-1.409-.319-1.409c-2.298 0-3.741 1.811-3.741 4.445 0 2.701 1.594 4.445 3.842 4.445" clipPath="url(#mdrt-center-full-logo-reverse_svg__q)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 165.436 104.91)" />;
    $[86] = t86;
  } else {
    t86 = $[86];
  }
  let t87;
  if ($[87] === Symbol.for("react.memo_cache_sentinel")) {
    t87 = <path d="M130.658 12.011h1.627V3.522h-1.627zm-.016 3.355h1.643v-1.66h-1.643z" clipPath="url(#mdrt-center-full-logo-reverse_svg__r)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 0 111.217)" />;
    $[87] = t87;
  } else {
    t87 = $[87];
  }
  let t88;
  if ($[88] === Symbol.for("react.memo_cache_sentinel")) {
    t88 = <path d="M0 0h1.578v-1.124c0-.335-.035-.621-.035-.621h.035C1.913-1.006 2.919.201 4.764.201c1.997 0 2.919-1.09 2.919-3.254v-5.436H6.056v5.067c0 1.191-.252 2.13-1.61 2.13-1.292 0-2.332-.855-2.685-2.08-.099-.336-.134-.722-.134-1.141v-3.976H0Z" clipPath="url(#mdrt-center-full-logo-reverse_svg__s)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 179.783 95.202)" />;
    $[88] = t88;
  } else {
    t88 = $[88];
  }
  let t89;
  if ($[89] === Symbol.for("react.memo_cache_sentinel")) {
    t89 = <path d="M0 0c0 2.214-1.074 2.852-2.399 2.852-1.476 0-2.315-1.074-2.315-2.802 0-1.761.94-2.969 2.466-2.969C-1.074-2.919 0-2.214 0 0m-2.718-6.543c1.477 0 2.685.655 2.685 2.383v.62c0 .269.017.537.017.537h-.035c-.502-.839-1.291-1.325-2.515-1.325-2.366 0-3.792 1.895-3.792 4.345 0 2.432 1.36 4.244 3.708 4.244 2.046 0 2.667-1.258 2.667-1.258h.034s-.018.117-.018.268v.789h1.561v-8.136c0-2.802-2.13-3.876-4.277-3.876a6.6 6.6 0 0 0-2.903.705l.537 1.275s1.056-.571 2.331-.571" clipPath="url(#mdrt-center-full-logo-reverse_svg__t)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 201.016 100.615)" />;
    $[89] = t89;
  } else {
    t89 = $[89];
  }
  let t90;
  if ($[90] === Symbol.for("react.memo_cache_sentinel")) {
    t90 = <path d="M0 0h1.66v-10.4h5.301v-1.443H0Z" clipPath="url(#mdrt-center-full-logo-reverse_svg__u)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 212.746 90.73)" />;
    $[90] = t90;
  } else {
    t90 = $[90];
  }
  let t91;
  if ($[91] === Symbol.for("react.memo_cache_sentinel")) {
    t91 = <path d="M0 0c-.051 1.459-.955 2.164-2.046 2.164-1.241 0-2.248-.772-2.483-2.164Zm-2.013 3.456c2.399 0 3.675-1.778 3.675-3.976 0-.218-.051-.705-.051-.705h-6.19c.084-1.862 1.409-2.801 2.919-2.801 1.459 0 2.515.99 2.515.99l.672-1.191S.269-5.435-1.761-5.435c-2.668 0-4.496 1.929-4.496 4.445 0 2.701 1.828 4.446 4.244 4.446" clipPath="url(#mdrt-center-full-logo-reverse_svg__v)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 231.697 99.542)" />;
    $[91] = t91;
  } else {
    t91 = $[91];
  }
  let t92;
  if ($[92] === Symbol.for("react.memo_cache_sentinel")) {
    t92 = <path d="M0 0c1.376 0 2.264 1.443 2.264 2.701v.268h-.419c-1.225 0-3.439-.083-3.439-1.61C-1.594.671-1.056 0 0 0m1.879 4.194h.369v.151c0 1.392-.789 1.862-1.862 1.862-1.309 0-2.366-.822-2.366-.822l-.67 1.191S-1.426 7.583.52 7.583c2.147 0 3.355-1.175 3.355-3.322v-5.368h-1.51v.805c0 .386.034.671.034.671h-.034S1.678-1.308-.353-1.308c-1.459 0-2.885.889-2.885 2.583 0 2.802 3.69 2.919 5.117 2.919" clipPath="url(#mdrt-center-full-logo-reverse_svg__w)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 239.957 105.044)" />;
    $[92] = t92;
  } else {
    t92 = $[92];
  }
  let t93;
  if ($[93] === Symbol.for("react.memo_cache_sentinel")) {
    t93 = <path d="M0 0c1.257 0 2.449.889 2.449 3.053 0 1.51-.789 3.02-2.4 3.02-1.341 0-2.448-1.108-2.448-3.037C-2.399 1.191-1.41 0 0 0m-.218 7.481c1.962 0 2.617-1.341 2.617-1.341h.033s-.033.251-.033.57v3.925h1.627V-1.208H2.483v.805c0 .336.016.571.016.571h-.034S1.778-1.409-.319-1.409c-2.298 0-3.741 1.811-3.741 4.445 0 2.701 1.594 4.445 3.842 4.445" clipPath="url(#mdrt-center-full-logo-reverse_svg__x)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 253.047 104.91)" />;
    $[93] = t93;
  } else {
    t93 = $[93];
  }
  let t94;
  if ($[94] === Symbol.for("react.memo_cache_sentinel")) {
    t94 = <path d="M0 0c-.051 1.459-.955 2.164-2.046 2.164-1.241 0-2.248-.772-2.483-2.164Zm-2.013 3.456c2.399 0 3.675-1.778 3.675-3.976 0-.218-.051-.705-.051-.705h-6.19c.084-1.862 1.409-2.801 2.919-2.801 1.459 0 2.515.99 2.515.99l.672-1.191S.269-5.435-1.761-5.435c-2.668 0-4.496 1.929-4.496 4.445 0 2.701 1.828 4.446 4.244 4.446" clipPath="url(#mdrt-center-full-logo-reverse_svg__y)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 269.381 99.542)" />;
    $[94] = t94;
  } else {
    t94 = $[94];
  }
  let t95;
  if ($[95] === Symbol.for("react.memo_cache_sentinel")) {
    t95 = <path d="M0 0h1.578v-1.477c0-.352-.035-.637-.035-.637h.035C1.964-.873 2.953.1 4.261.1c.218 0 .419-.033.419-.033v-1.61s-.218.05-.469.05c-1.041 0-1.996-.738-2.382-1.997-.151-.486-.202-1.006-.202-1.526v-3.473H0Z" clipPath="url(#mdrt-center-full-logo-reverse_svg__z)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 274.24 95.202)" />;
    $[95] = t95;
  } else {
    t95 = $[95];
  }
  let t96;
  if ($[96] === Symbol.for("react.memo_cache_sentinel")) {
    t96 = <path d="M0 0s.956-.99 2.432-.99c.705 0 1.41.369 1.41 1.057 0 1.56-4.362 1.241-4.362 4.009 0 1.544 1.375 2.416 3.07 2.416 1.862 0 2.734-.94 2.734-.94L4.63 4.328s-.755.755-2.097.755c-.705 0-1.393-.302-1.393-1.041 0-1.526 4.362-1.19 4.362-3.975 0-1.409-1.208-2.466-3.07-2.466-2.079 0-3.221 1.242-3.221 1.242z" clipPath="url(#mdrt-center-full-logo-reverse_svg__A)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 282.769 103.59)" />;
    $[96] = t96;
  } else {
    t96 = $[96];
  }
  let t97;
  if ($[97] === Symbol.for("react.memo_cache_sentinel")) {
    t97 = <path d="M0 0h-1.107v1.308H.051v2.45h1.576v-2.45h2.047V0H1.627v-3.774c0-1.695 1.191-1.913 1.812-1.913.235 0 .386.034.386.034v-1.443s-.234-.034-.571-.034C2.164-7.13 0-6.794 0-3.959Z" clipPath="url(#mdrt-center-full-logo-reverse_svg__B)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 298.88 97.104)" />;
    $[97] = t97;
  } else {
    t97 = $[97];
  }
  let t98;
  if ($[98] === Symbol.for("react.memo_cache_sentinel")) {
    t98 = <path d="M0 0c1.611 0 2.919 1.275 2.919 3.053 0 1.762-1.308 3.02-2.919 3.02-1.594 0-2.919-1.258-2.919-3.02C-2.919 1.275-1.594 0 0 0m0 7.481c2.533 0 4.579-1.861 4.579-4.428C4.579.47 2.533-1.409 0-1.409S-4.579.47-4.579 3.053c0 2.567 2.046 4.428 4.579 4.428" clipPath="url(#mdrt-center-full-logo-reverse_svg__C)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 311.7 104.91)" />;
    $[98] = t98;
  } else {
    t98 = $[98];
  }
  let t99;
  if ($[99] === Symbol.for("react.memo_cache_sentinel")) {
    t99 = <path d="M0 0c1.275 0 2.029.805 2.029 2.013s-.805 2.03-2.046 2.03h-2.65V0Zm-.185 5.418c1.074 0 1.744.755 1.744 1.795S.922 8.958-.218 8.958h-2.449v-3.54ZM-4.329 10.4h4.144c1.997 0 3.439-1.107 3.439-3.019 0-1.157-.571-2.08-1.477-2.55v-.034c1.242-.368 1.947-1.543 1.947-2.868 0-2.231-1.728-3.372-3.808-3.372h-4.245z" clipPath="url(#mdrt-center-full-logo-reverse_svg__D)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 332.355 104.596)" />;
    $[99] = t99;
  } else {
    t99 = $[99];
  }
  let t100;
  if ($[100] === Symbol.for("react.memo_cache_sentinel")) {
    t100 = <path d="M0 0h1.627v-5.066c0-1.175.235-2.114 1.594-2.114 1.728 0 2.751 1.527 2.751 3.204V0h1.627v-8.489H6.023v1.125c0 .352.033.62.033.62h-.033C5.67-7.583 4.563-8.69 2.902-8.69.99-8.69 0-7.684 0-5.435Z" clipPath="url(#mdrt-center-full-logo-reverse_svg__E)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 340.168 95.202)" />;
    $[100] = t100;
  } else {
    t100 = $[100];
  }
  let t101;
  if ($[101] === Symbol.for("react.memo_cache_sentinel")) {
    t101 = <path d="M265.279 12.011h1.627V3.522h-1.627zm-.016 3.355h1.643v-1.66h-1.643z" clipPath="url(#mdrt-center-full-logo-reverse_svg__F)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 0 111.217)" />;
    $[101] = t101;
  } else {
    t101 = $[101];
  }
  let t102;
  if ($[102] === Symbol.for("react.memo_cache_sentinel")) {
    t102 = <path d="M0 0h1.627v-9.243c0-1.023.402-1.208.906-1.208.15 0 .285.017.285.017v-1.442s-.252-.034-.536-.034C1.358-11.91 0-11.659 0-9.528Z" clipPath="url(#mdrt-center-full-logo-reverse_svg__G)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 359.145 90.73)" />;
    $[102] = t102;
  } else {
    t102 = $[102];
  }
  let t103;
  if ($[103] === Symbol.for("react.memo_cache_sentinel")) {
    t103 = <path d="M0 0c1.257 0 2.449.889 2.449 3.053 0 1.51-.789 3.02-2.398 3.02-1.343 0-2.45-1.108-2.45-3.037C-2.399 1.191-1.41 0 0 0m-.218 7.481c1.962 0 2.617-1.341 2.617-1.341h.033s-.033.251-.033.57v3.925h1.627V-1.208H2.483v.805c0 .336.016.571.016.571h-.034S1.777-1.409-.319-1.409c-2.298 0-3.741 1.811-3.741 4.445 0 2.701 1.594 4.445 3.842 4.445" clipPath="url(#mdrt-center-full-logo-reverse_svg__H)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 369.883 104.91)" />;
    $[103] = t103;
  } else {
    t103 = $[103];
  }
  let t104;
  if ($[104] === Symbol.for("react.memo_cache_sentinel")) {
    t104 = <path d="M0 0s1.257-1.275 3.019-1.275c1.108 0 2.047.621 2.047 1.745 0 2.567-5.738 2.013-5.738 5.653 0 1.845 1.594 3.305 3.825 3.305 2.198 0 3.355-1.191 3.355-1.191l-.754-1.376S4.663 7.885 3.153 7.885c-1.257 0-2.147-.789-2.147-1.729 0-2.449 5.738-1.794 5.738-5.636 0-1.828-1.41-3.338-3.759-3.338-2.515 0-3.924 1.56-3.924 1.56z" clipPath="url(#mdrt-center-full-logo-reverse_svg__I)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 384.901 103.03)" />;
    $[104] = t104;
  } else {
    t104 = $[104];
  }
  let t105;
  if ($[105] === Symbol.for("react.memo_cache_sentinel")) {
    t105 = <path d="M0 0h1.627v-5.066c0-1.175.235-2.114 1.594-2.114 1.728 0 2.751 1.527 2.751 3.204V0h1.627v-8.489H6.023v1.125c0 .352.033.62.033.62h-.033C5.67-7.583 4.563-8.69 2.902-8.69.99-8.69 0-7.684 0-5.435Z" clipPath="url(#mdrt-center-full-logo-reverse_svg__J)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 396.47 95.202)" />;
    $[105] = t105;
  } else {
    t105 = $[105];
  }
  let t106;
  if ($[106] === Symbol.for("react.memo_cache_sentinel")) {
    t106 = <path d="M0 0c2.13 0 3.186-1.241 3.186-1.241l-.771-1.141s-.906.973-2.348.973c-1.711 0-2.953-1.275-2.953-3.019 0-1.728 1.242-3.053 3.003-3.053 1.577 0 2.617 1.14 2.617 1.14l.655-1.191S2.214-8.891 0-8.891c-2.667 0-4.547 1.896-4.547 4.446C-4.547-1.929-2.667 0 0 0" clipPath="url(#mdrt-center-full-logo-reverse_svg__K)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 415.267 94.934)" />;
    $[106] = t106;
  } else {
    t106 = $[106];
  }
  let t107;
  if ($[107] === Symbol.for("react.memo_cache_sentinel")) {
    t107 = <path d="M0 0c2.13 0 3.186-1.241 3.186-1.241l-.771-1.141s-.906.973-2.348.973c-1.711 0-2.953-1.275-2.953-3.019 0-1.728 1.242-3.053 3.003-3.053 1.577 0 2.617 1.14 2.617 1.14l.655-1.191S2.214-8.891 0-8.891c-2.667 0-4.547 1.896-4.547 4.446C-4.547-1.929-2.667 0 0 0" clipPath="url(#mdrt-center-full-logo-reverse_svg__L)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 427.508 94.934)" />;
    $[107] = t107;
  } else {
    t107 = $[107];
  }
  let t108;
  if ($[108] === Symbol.for("react.memo_cache_sentinel")) {
    t108 = <path d="M0 0c-.051 1.459-.955 2.164-2.046 2.164-1.241 0-2.248-.772-2.483-2.164Zm-2.013 3.456c2.399 0 3.675-1.778 3.675-3.976 0-.218-.051-.705-.051-.705h-6.19c.084-1.862 1.409-2.801 2.919-2.801 1.459 0 2.515.99 2.515.99l.672-1.191S.269-5.435-1.761-5.435c-2.668 0-4.496 1.929-4.496 4.445 0 2.701 1.828 4.446 4.244 4.446" clipPath="url(#mdrt-center-full-logo-reverse_svg__M)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 442.05 99.542)" />;
    $[108] = t108;
  } else {
    t108 = $[108];
  }
  let t109;
  if ($[109] === Symbol.for("react.memo_cache_sentinel")) {
    t109 = <path d="M0 0s.957-.99 2.432-.99c.705 0 1.41.369 1.41 1.057 0 1.56-4.362 1.241-4.362 4.009 0 1.544 1.375 2.416 3.07 2.416 1.862 0 2.734-.94 2.734-.94L4.63 4.328s-.755.755-2.097.755c-.705 0-1.393-.302-1.393-1.041 0-1.526 4.362-1.19 4.362-3.975 0-1.409-1.208-2.466-3.07-2.466-2.079 0-3.221 1.242-3.221 1.242z" clipPath="url(#mdrt-center-full-logo-reverse_svg__N)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 447.046 103.59)" />;
    $[109] = t109;
  } else {
    t109 = $[109];
  }
  let t110;
  if ($[110] === Symbol.for("react.memo_cache_sentinel")) {
    t110 = <path d="M0 0s.956-.99 2.432-.99c.705 0 1.41.369 1.41 1.057 0 1.56-4.362 1.241-4.362 4.009 0 1.544 1.375 2.416 3.07 2.416 1.862 0 2.734-.94 2.734-.94L4.63 4.328s-.755.755-2.097.755c-.705 0-1.393-.302-1.393-1.041 0-1.526 4.362-1.19 4.362-3.975 0-1.409-1.208-2.466-3.07-2.466-2.079 0-3.221 1.242-3.221 1.242z" clipPath="url(#mdrt-center-full-logo-reverse_svg__O)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 457.071 103.59)" />;
    $[110] = t110;
  } else {
    t110 = $[110];
  }
  let t111;
  if ($[111] === Symbol.for("react.memo_cache_sentinel")) {
    t111 = <path d="M0 0h5.163l5.201-13.133c.599-1.571 1.347-3.891 1.347-3.891h.075s.711 2.32 1.309 3.891L18.296 0h5.163l2.133-26.565h-4.789L19.68-11.711c-.112 1.758-.037 4.116-.037 4.116h-.075s-.785-2.582-1.421-4.116L13.844-22H9.616L5.351-11.711c-.637 1.534-1.46 4.153-1.46 4.153h-.074s.074-2.395-.038-4.153L2.657-26.565H-2.17Z" clipPath="url(#mdrt-center-full-logo-reverse_svg__P)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 125.179 .647)" />;
    $[111] = t111;
  } else {
    t111 = $[111];
  }
  let t112;
  if ($[112] === Symbol.for("react.memo_cache_sentinel")) {
    t112 = <path d="M0 0c5.388 0 8.83 3.18 8.83 9.167 0 5.911-3.517 9.092-8.83 9.092h-3.966V0Zm-8.793 22.412H.262c8.194 0 13.544-4.864 13.544-13.245S8.456-4.153.262-4.153h-9.055z" clipPath="url(#mdrt-center-full-logo-reverse_svg__Q)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 178.902 30.529)" />;
    $[112] = t112;
  } else {
    t112 = $[112];
  }
  let t113;
  if ($[113] === Symbol.for("react.memo_cache_sentinel")) {
    t113 = <path d="M0 0c2.581 0 4.191 1.534 4.191 4.191 0 2.544-1.086 4.116-4.865 4.116H-4.34V0Zm-9.167 12.459h8.568c2.881 0 4.191-.224 5.35-.748 2.657-1.197 4.341-3.741 4.341-7.258 0-3.181-1.684-6.137-4.49-7.259v-.075s.374-.374.898-1.31l5.462-9.914H5.575L.299-4.191H-4.34v-9.914h-4.827z" clipPath="url(#mdrt-center-full-logo-reverse_svg__R)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 216.264 17.26)" />;
    $[113] = t113;
  } else {
    t113 = $[113];
  }
  let t114;
  if ($[114] === Symbol.for("react.memo_cache_sentinel")) {
    t114 = <path d="M0 0h-8.718v4.153h22.263V0H4.826v-22.412H0Z" clipPath="url(#mdrt-center-full-logo-reverse_svg__S)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 244.196 6.184)" />;
    $[114] = t114;
  } else {
    t114 = $[114];
  }
  let t115;
  if ($[115] === Symbol.for("react.memo_cache_sentinel")) {
    t115 = <path d="M0 0c6.473 0 9.803-3.63 9.803-3.63l-2.32-3.591S4.453-4.415.225-4.415c-5.613 0-8.905-4.191-8.905-9.13 0-5.051 3.404-9.503 8.942-9.503 4.602 0 7.708 3.368 7.708 3.368l2.544-3.481S6.847-27.463.075-27.463c-8.119 0-13.732 6.024-13.732 13.844C-13.657-5.912-7.82 0 0 0" clipPath="url(#mdrt-center-full-logo-reverse_svg__T)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 294.827 .048)" />;
    $[115] = t115;
  } else {
    t115 = $[115];
  }
  let t116;
  if ($[116] === Symbol.for("react.memo_cache_sentinel")) {
    t116 = <path d="M0 0h15.901v-4.153H4.826v-6.959h8.943v-4.154H4.826v-7.146H16.5v-4.153H0Z" clipPath="url(#mdrt-center-full-logo-reverse_svg__U)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 314.777 .647)" />;
    $[116] = t116;
  } else {
    t116 = $[116];
  }
  let t117;
  if ($[117] === Symbol.for("react.memo_cache_sentinel")) {
    t117 = <path d="M0 0h4.826l10.065-15.34c1.01-1.534 2.208-4.116 2.208-4.116h.075s-.262 2.544-.262 4.116V0h4.789v-26.565h-4.789L6.847-11.262c-1.01 1.534-2.208 4.116-2.208 4.116h-.074s.261-2.545.261-4.116v-15.303H0Z" clipPath="url(#mdrt-center-full-logo-reverse_svg__V)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 342.085 .647)" />;
    $[117] = t117;
  } else {
    t117 = $[117];
  }
  let t118;
  if ($[118] === Symbol.for("react.memo_cache_sentinel")) {
    t118 = <path d="M0 0h-8.718v4.153h22.263V0H4.826v-22.412H0Z" clipPath="url(#mdrt-center-full-logo-reverse_svg__W)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 387.549 6.184)" />;
    $[118] = t118;
  } else {
    t118 = $[118];
  }
  let t119;
  if ($[119] === Symbol.for("react.memo_cache_sentinel")) {
    t119 = <path d="M0 0h15.901v-4.153H4.826v-6.959h8.943v-4.154H4.826v-7.146H16.5v-4.153H0Z" clipPath="url(#mdrt-center-full-logo-reverse_svg__X)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 410.515 .647)" />;
    $[119] = t119;
  } else {
    t119 = $[119];
  }
  let t120;
  if ($[120] === Symbol.for("react.memo_cache_sentinel")) {
    t120 = <path d="M0 0c2.582 0 4.191 1.534 4.191 4.191 0 2.544-1.086 4.116-4.865 4.116H-4.34V0Zm-9.167 12.459h8.568c2.881 0 4.191-.224 5.35-.748 2.657-1.197 4.341-3.741 4.341-7.258 0-3.181-1.684-6.137-4.49-7.259v-.075s.374-.374.898-1.31l5.463-9.914H5.575L.299-4.191H-4.34v-9.914h-4.827z" clipPath="url(#mdrt-center-full-logo-reverse_svg__Y)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 449.68 17.26)" />;
    $[120] = t120;
  } else {
    t120 = $[120];
  }
  let t121;
  if ($[121] === Symbol.for("react.memo_cache_sentinel")) {
    t121 = <path d="M0 0h-1.547v2.48H0v.565c0 4.1 3.364 4.64 5.107 4.64.638 0 1.056-.073 1.056-.073V4.96s-.27.049-.638.049c-.884 0-2.407-.221-2.407-2.038V2.48h2.677V0H3.118v-9.846H0Z" clipPath="url(#mdrt-center-full-logo-reverse_svg__Z)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 124.348 59.621)" />;
    $[121] = t121;
  } else {
    t121 = $[121];
  }
  let t122;
  if ($[122] === Symbol.for("react.memo_cache_sentinel")) {
    t122 = <path d="M0 0c2.013 0 3.707 1.571 3.707 3.904 0 2.308-1.694 3.904-3.707 3.904-2.038 0-3.732-1.596-3.732-3.904C-3.732 1.571-2.038 0 0 0m-.025 10.46c3.831 0 6.9-2.726 6.9-6.556C6.875.049 3.806-2.652 0-2.652c-3.83 0-6.9 2.701-6.9 6.556 0 3.83 3.07 6.556 6.875 6.556" clipPath="url(#mdrt-center-full-logo-reverse_svg__aa)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 142.811 69.606)" />;
    $[122] = t122;
  } else {
    t122 = $[122];
  }
  let t123;
  if ($[123] === Symbol.for("react.memo_cache_sentinel")) {
    t123 = <path d="M0 0h2.996v-2.161c0-.466-.049-.884-.049-.884h.049C3.561-1.252 5.058.172 6.973.172c.295 0 .565-.05.565-.05v-3.069s-.319.05-.737.05c-1.325 0-2.823-.762-3.412-2.628-.197-.614-.27-1.301-.27-2.038v-4.96H0Z" clipPath="url(#mdrt-center-full-logo-reverse_svg__ab)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 155.315 56.052)" />;
    $[123] = t123;
  } else {
    t123 = $[123];
  }
  let t124;
  if ($[124] === Symbol.for("react.memo_cache_sentinel")) {
    t124 = <path d="M0 0h10.018v-2.725H3.167v-4.936h5.77v-2.725h-5.77v-7.047H0Z" clipPath="url(#mdrt-center-full-logo-reverse_svg__ac)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 176.789 49.505)" />;
    $[124] = t124;
  } else {
    t124 = $[124];
  }
  let t125;
  if ($[125] === Symbol.for("react.memo_cache_sentinel")) {
    t125 = <path d="M145.622 46.284h3.167V28.851h-3.167z" clipPath="url(#mdrt-center-full-logo-reverse_svg__ad)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 0 111.217)" />;
    $[125] = t125;
  } else {
    t125 = $[125];
  }
  let t126;
  if ($[126] === Symbol.for("react.memo_cache_sentinel")) {
    t126 = <path d="M0 0h10.435v-2.725H3.167v-4.567h5.869v-2.726H3.167v-4.689h7.661v-2.726H0Z" clipPath="url(#mdrt-center-full-logo-reverse_svg__ae)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 204.22 49.505)" />;
    $[126] = t126;
  } else {
    t126 = $[126];
  }
  let t127;
  if ($[127] === Symbol.for("react.memo_cache_sentinel")) {
    t127 = <path d="M0 0h3.167v-14.707h7.538v-2.726H0Z" clipPath="url(#mdrt-center-full-logo-reverse_svg__af)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 223.043 49.505)" />;
    $[127] = t127;
  } else {
    t127 = $[127];
  }
  let t128;
  if ($[128] === Symbol.for("react.memo_cache_sentinel")) {
    t128 = <path d="M0 0c3.536 0 5.794 2.087 5.794 6.016 0 3.879-2.307 5.966-5.794 5.966h-2.603V0Zm-5.77 14.707H.172c5.377 0 8.888-3.191 8.888-8.691S5.549-2.726.172-2.726H-5.77Z" clipPath="url(#mdrt-center-full-logo-reverse_svg__ag)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 248.38 69.115)" />;
    $[128] = t128;
  } else {
    t128 = $[128];
  }
  let t129;
  if ($[129] === Symbol.for("react.memo_cache_sentinel")) {
    t129 = <path d="M0 0h3.167v-14.707h7.538v-2.726H0Z" clipPath="url(#mdrt-center-full-logo-reverse_svg__ah)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 272.832 49.505)" />;
    $[129] = t129;
  } else {
    t129 = $[129];
  }
  let t130;
  if ($[130] === Symbol.for("react.memo_cache_sentinel")) {
    t130 = <path d="M0 0h10.435v-2.725H3.167v-4.567h5.869v-2.726H3.167v-4.689h7.661v-2.726H0Z" clipPath="url(#mdrt-center-full-logo-reverse_svg__ai)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 290.475 49.505)" />;
    $[130] = t130;
  } else {
    t130 = $[130];
  }
  let t131;
  if ($[131] === Symbol.for("react.memo_cache_sentinel")) {
    t131 = <path d="M0 0s-.393-1.719-.737-2.701l-1.547-4.665h4.567L.736-2.701C.417-1.719.049 0 .049 0Zm3.069-9.944h-6.114l-1.473-4.469h-3.266L-1.645 3.02h3.314l6.139-17.433H4.542Z" clipPath="url(#mdrt-center-full-logo-reverse_svg__aj)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 316.762 53.532)" />;
    $[131] = t131;
  } else {
    t131 = $[131];
  }
  let t132;
  if ($[132] === Symbol.for("react.memo_cache_sentinel")) {
    t132 = <path d="M0 0c3.536 0 5.794 2.087 5.794 6.016 0 3.879-2.307 5.966-5.794 5.966h-2.603V0Zm-5.77 14.707H.172c5.377 0 8.888-3.191 8.888-8.691S5.549-2.726.172-2.726H-5.77Z" clipPath="url(#mdrt-center-full-logo-reverse_svg__ak)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 337.843 69.115)" />;
    $[132] = t132;
  } else {
    t132 = $[132];
  }
  let t133;
  if ($[133] === Symbol.for("react.memo_cache_sentinel")) {
    t133 = <path d="M0 0h10.435v-2.725H3.167v-4.567h5.869v-2.726H3.167v-4.689h7.661v-2.726H0Z" clipPath="url(#mdrt-center-full-logo-reverse_svg__al)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 354.34 49.505)" />;
    $[133] = t133;
  } else {
    t133 = $[133];
  }
  let t134;
  if ($[134] === Symbol.for("react.memo_cache_sentinel")) {
    t134 = <path d="M0 0c1.694 0 2.75 1.007 2.75 2.75 0 1.67-.712 2.701-3.192 2.701h-2.407V0Zm-6.016 8.176h5.623c1.891 0 2.75-.147 3.511-.491C4.862 6.9 5.966 5.23 5.966 2.922c0-2.087-1.104-4.027-2.946-4.764v-.048s.245-.246.589-.86l3.585-6.507H3.658L.197-2.75h-3.046v-6.507h-3.167z" clipPath="url(#mdrt-center-full-logo-reverse_svg__am)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 381.184 60.407)" />;
    $[134] = t134;
  } else {
    t134 = $[134];
  }
  let t135;
  if ($[135] === Symbol.for("react.memo_cache_sentinel")) {
    t135 = <path d="M0 0s1.891-1.842 4.346-1.842c1.326 0 2.529.688 2.529 2.112 0 3.118-8.225 2.578-8.225 7.931 0 2.897 2.504 5.058 5.844 5.058 3.437 0 5.205-1.866 5.205-1.866L8.324 8.815s-1.67 1.522-3.855 1.522c-1.473 0-2.627-.859-2.627-2.087 0-3.094 8.201-2.333 8.201-7.906 0-2.775-2.112-5.108-5.746-5.108-3.88 0-6.016 2.382-6.016 2.382z" clipPath="url(#mdrt-center-full-logo-reverse_svg__an)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 395.226 66.79)" />;
    $[135] = t135;
  } else {
    t135 = $[135];
  }
  let t136;
  if ($[136] === Symbol.for("react.memo_cache_sentinel")) {
    t136 = <path d="M0 0h3.167v-7.391h7.98V0h3.168v-17.433h-3.168v7.317h-7.98v-7.317H0Z" clipPath="url(#mdrt-center-full-logo-reverse_svg__ao)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 412.837 49.505)" />;
    $[136] = t136;
  } else {
    t136 = $[136];
  }
  let t137;
  if ($[137] === Symbol.for("react.memo_cache_sentinel")) {
    t137 = <path d="M328.36 46.284h3.167V28.851h-3.167z" clipPath="url(#mdrt-center-full-logo-reverse_svg__ap)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 0 111.217)" />;
    $[137] = t137;
  } else {
    t137 = $[137];
  }
  let t138;
  if ($[138] === Symbol.for("react.memo_cache_sentinel")) {
    t138 = <path d="M0 0c1.842 0 2.922 1.178 2.922 2.995 0 1.793-1.08 2.947-2.873 2.947h-3.02V0Zm-6.138 8.667H.59c3.265 0 5.549-2.283 5.549-5.672S3.855-2.75.59-2.75h-3.561v-6.016h-3.167z" clipPath="url(#mdrt-center-full-logo-reverse_svg__aq)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 456.112 61.061)" />;
    $[138] = t138;
  } else {
    t138 = $[138];
  }
  let t139;
  if ($[139] === Symbol.for("react.memo_cache_sentinel")) {
    t139 = <path d="M0 0c.222 0 .358.142.358.371 0 .236-.136.364-.351.364h-.324V0Zm-.889 1.153H.135c.486 0 .81-.31.81-.782A.65.65 0 0 0 .507-.27v-.013S.533-.31.593-.425l.466-.889H.425l-.418.909h-.324v-.909h-.572zm.842-3.176c1.039 0 1.834.85 1.834 1.929 0 1.072-.795 1.921-1.834 1.921-1.019 0-1.807-.849-1.807-1.921 0-1.079.788-1.929 1.807-1.929m0 4.396c1.348 0 2.427-1.098 2.427-2.467S1.301-2.569-.047-2.569c-1.328 0-2.407 1.106-2.407 2.475s1.079 2.467 2.407 2.467" clipPath="url(#mdrt-center-full-logo-reverse_svg__ar)" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="matrix(1.33333 0 0 -1.33333 469.866 52.67)" />;
    $[139] = t139;
  } else {
    t139 = $[139];
  }
  let t140;
  if ($[140] !== props) {
    t140 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 473.04 111.217" {...props}>{t69}{t70}{t71}{t72}{t73}{t74}{t75}{t76}{t77}{t78}{t79}{t80}{t81}{t82}{t83}{t84}{t85}{t86}{t87}{t88}{t89}{t90}{t91}{t92}{t93}{t94}{t95}{t96}{t97}{t98}{t99}{t100}{t101}{t102}{t103}{t104}{t105}{t106}{t107}{t108}{t109}{t110}{t111}{t112}{t113}{t114}{t115}{t116}{t117}{t118}{t119}{t120}{t121}{t122}{t123}{t124}{t125}{t126}{t127}{t128}{t129}{t130}{t131}{t132}{t133}{t134}{t135}{t136}{t137}{t138}{t139}</svg>;
    $[140] = props;
    $[141] = t140;
  } else {
    t140 = $[141];
  }
  return t140;
};
export default SvgMdrtCenterFullLogoReverse;